module.exports = __webpack_public_path__ + "img/11.c0444dc1.png";